export default __webpack_public_path__ + "static/media/InCommand_Logo_Primary_Icon.f924043b.png";